import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/main';

import { PropertyDetailPopupComponent, PropertyDetailPopupAnchorDirective } from '../popup';

@Component({
  selector: 'property-name-renderer',
  template: `<a style="cursor: pointer;" (click)="openPropertyDetailPopup()">
  {{params.value}}
</a>
<div propertyDetailPopupAnchor></div>`, entryComponents: [PropertyDetailPopupComponent]
})
export class PropertyNameRendererComponent implements ICellRendererAngularComp {
  public params: any;
  @ViewChild(PropertyDetailPopupAnchorDirective) propertyDetailPopupAnchor: PropertyDetailPopupAnchorDirective;

  agInit(params: any): void {
    this.params = params;
  }

  openPropertyDetailPopup() {
    this.propertyDetailPopupAnchor.createPropertyDetailPopup(PropertyDetailPopupComponent, this.params.data);
  }

  refresh(params: any): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/grids/property-name-renderer.component.ts